import { IVictimFull } from "../types/common";
import { Locale } from "../types/common";
import { VictimForm } from "../types/VictimForm";
import { toLocalCalendarDate } from "./toUtcNoonISOString";

export function getVictimFormValues(
  victim: IVictimFull,
  locale: Locale,
): VictimForm {
  const {
    name = "",
    surname = "",
    fatherName = "",
    biography = "",
    position = "",
  } = victim.content[locale] ?? {};

  return {
    name,
    surname,
    fatherName: fatherName ?? "",
    birthDate: victim.birthDate
      ? toLocalCalendarDate(victim.birthDate)
      : null,
    deathDate: victim.deathDate
      ? toLocalCalendarDate(victim.deathDate)
      : null,
    noDeathDate: !victim.deathDate,
    isMilitary: victim.isMilitary,
    position,
    biography,
    image: victim.image,
    email: victim.email ?? "",
    phone: victim.phone ?? undefined,
    hasMedal: victim.hasMedal,
    sex: victim.sex,
    brigade: victim.brigade
      ? {
          value: victim.brigade.id,
          label: victim.brigade.name,
          image: victim.brigade.image,
        }
      : null,
  };
}
